import React, { useState } from 'react';
import {
    ValidationForm,
    Grid,
    Btn,
    Box,
    P,
    FieldCheckbox,
} from '@saladbob/sassafras'

import { X } from 'react-feather';

import Upload from '../Upload';
import { Text, MackerTagField } from './Fields';

import { User } from '../../types';

type Props = {
    onSubmit: Function,
    setUser: Function,
    user: User & { password?: string, password_confirm?: string },
    children?: React.ReactNode,
};

const UserVanity: React.FC<Props> = ({ user, setUser, onSubmit, children }) => {
    const showMackerTag = user?.type === 'player';

    return (
        <ValidationForm onSubmit={onSubmit}>
            <Grid bgColor="white" gridGap={{ phone: 'sm', laptop: 'lg' }} mb="md">
                <Box maxWidth="240px" margin="auto">
                    {!user.imageUpload && user.image && user.image.url
                        ? (<Box
                                height="240px"
                                bgImage={user.image.sizes.thumbnail.url || user.image.url}
                                rounded="100%"
                                verticalAlign="center"
                                align="center"
                            >
                                <Btn type="button" onClick={() => setUser({ image: null })}>
                                    <X />
                                </Btn>
                            </Box>)
                        : (<Upload
                            name="logo"
                            files={user.imageUpload ? (Array.isArray(user.imageUpload) ?  user.imageUpload : [user.imageUpload]) : [] }
                            onChange={(image) => setUser({ imageUpload: image })}
                        />)
                    }
                </Box>
                {showMackerTag && (
                    <MackerTagField name="mackertag" user={user} />
                )}
                <FieldCheckbox
                    checked={user?.sms ? true : false}
                    size="sm"
                    name="sms"
                    mb="0"
                    inline={false}
                    label={(
                        <P mb="0">
                            Stay in the game with real-time updates and exclusive notifications for Gus Macker 
                            basketball events! Opt-in for SMS alerts and be the first to know about game schedules, 
                            scores, special offers, and more.
                        </P>
                    )}
                />

                {!user.id && (
                    <FieldCheckbox
                        name="optin"
                        size="sm"
                        mb="0"
                        inline={false}
                        label={(
                            <P mb="0">
                                I agree to the 
                                <a href="/terms-of-service" target="blank">Terms of Service</a>
                                {' '}
                                and
                                {' '}
                                <a href="/privacy-policy" target="blank">Privacy Policy</a>
                                {' '}
                                and agree to receive email notifications and marketing from Gus Macker.
                            </P>
                        )}
                        rules={{ required: true }}
                    />
                )}
            </Grid>
            {children}
        </ValidationForm>
    );
}

export default UserVanity;
